import { render, staticRenderFns } from "./mouse_button.vue?vue&type=template&id=7c78b1b7&scoped=true&"
import script from "./mouse_button.vue?vue&type=script&lang=js&"
export * from "./mouse_button.vue?vue&type=script&lang=js&"
import style0 from "./mouse_button.vue?vue&type=style&index=0&id=7c78b1b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c78b1b7",
  null
  
)

export default component.exports